import React from 'react';

interface PurchaseStepperProps {
  currentStep: 1 | 2 | 3;
  className?: string;
}

const STEPS = [
  { id: 1, label: 'Subscription' },
  { id: 2, label: 'Add-ons' },
  { id: 3, label: 'Checkout' },
] as const;

export default function PurchaseStepper({ currentStep, className = '' }: PurchaseStepperProps) {
  return (
    <div className={`w-full max-w-2xl mx-auto ${className}`.trim()} aria-label="Purchase progress">
      <div className="flex items-center gap-2">
        {STEPS.map((step, index) => {
          const isReached = step.id <= currentStep;
          const circleClassName = isReached
            ? 'bg-red-500 text-white shadow-sm'
            : 'bg-slate-300 text-slate-600';

          return (
            <React.Fragment key={step.id}>
              <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${circleClassName}`}>
                {step.id}
              </div>
              {index < STEPS.length - 1 && (
                <div className={`h-1 flex-1 rounded-full ${step.id < currentStep ? 'bg-red-500' : 'bg-slate-300'}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="mt-3 grid grid-cols-3 gap-2 text-center">
        {STEPS.map((step) => (
          <div
            key={step.id}
            className={`text-[11px] font-semibold uppercase tracking-[0.18em] ${step.id <= currentStep ? 'text-slate-800' : 'text-slate-400'}`}
          >
            {step.label}
          </div>
        ))}
      </div>
    </div>
  );
}
